import { createSelector } from '@reduxjs/toolkit'
import {
  getFromDesktopProperties,
  getWillDisplayContactInUserTimezone,
  getUserTimezone,
} from '../../../Common/DesktopProperties/desktopProperties.selectors'
import { ACTIONS as GOAL_ACTIONS } from '../CreateTask/createTask.constants'

const getStorageFile = state => state.storageFile.data
const getContactData = state => state.contact.data

const getSomeTimeline = type => (file = {}) => {
  const allFormats = Object.values(file)
  const startKey = type + 'Start'
  const durationKey = type + 'Duration'
  const endKey = type + 'End'
  const storageFileOffsetKey = type + 'StorageFileOffset'
  if (allFormats.length === 0 || allFormats[0].length === 0) {
    return {
      [startKey]: 0,
      [durationKey]: 0,
      [endKey]: 0,
      [storageFileOffsetKey]: 0,
    }
  } else {
    const { offsetMs, durationMs, storageFileOffsetMs } = allFormats[0][0]
    return {
      [startKey]: offsetMs,
      [durationKey]: durationMs,
      [endKey]: offsetMs + durationMs,
      [storageFileOffsetKey]: storageFileOffsetMs,
    }
  }
}

const computeMediaTimeline = (storageFile, contact) => {
  const audioTimeline = getSomeTimeline('audio')(storageFile.audio)
  const videoTimeline = getSomeTimeline('video')(storageFile.video)
  return {
    duration: contact.callDuration,
    ...audioTimeline,
    ...videoTimeline,
    afterCallLength: contact.callDuration - videoTimeline.videoDuration - videoTimeline.videoStart,
  }
}

export const getMediaTimeline = createSelector(
  [getStorageFile, getContactData],
  computeMediaTimeline,
)

const getAssociatedContacts = state => state.associatedContacts.data
const getContactId = state => (state.main.contact.data ? state.main.contact.data.id : null)

const nextAndPreviousContactIdsMapper = (contactId, associatedContacts) => {
  if (!contactId) {
    return {
      previous: null,
      next: null,
    }
  }

  const associatedContactIds = associatedContacts.map(({ id }) => id)
  const currentContactIndex = associatedContactIds.indexOf(contactId)

  const nextContactId =
    currentContactIndex !== -1 && currentContactIndex < associatedContactIds.length - 1
      ? associatedContactIds[currentContactIndex + 1]
      : null
  const previousContactId =
    currentContactIndex !== -1 && currentContactIndex > 0 ? associatedContactIds[currentContactIndex - 1] : null

  return {
    previous: previousContactId,
    next: nextContactId,
  }
}

export const getNextAndPreviousContactIds = createSelector(
  [getContactId, getAssociatedContacts],
  nextAndPreviousContactIdsMapper,
)

export const getDelayedStorageStatus = createSelector(
  state => state.media.main.storageFile.data,
  state => state.app.mediaFormats,
  (storage, mediaFormats) => {
    const delayedStorageStatus = {}

    if (
      // eslint-disable-next-line no-prototype-builtins -- TODO: remove this eslint-disable
      storage.hasOwnProperty('audio') &&
      // eslint-disable-next-line no-prototype-builtins -- TODO: remove this eslint-disable
      storage['audio'].hasOwnProperty(mediaFormats.audio) &&
      storage['audio'][mediaFormats.audio].length > 0
    ) {
      delayedStorageStatus.audio = storage['audio'][mediaFormats.audio][0].status === 'delayed'
    }

    if (
      // eslint-disable-next-line no-prototype-builtins -- TODO: remove this eslint-disable
      storage.hasOwnProperty('video') &&
      // eslint-disable-next-line no-prototype-builtins -- TODO: remove this eslint-disable
      storage['video'].hasOwnProperty(mediaFormats.video) &&
      storage['video'][mediaFormats.video].length > 0
    ) {
      delayedStorageStatus.video = storage['video'][mediaFormats.video][0].status === 'delayed'
    }

    if (
      // eslint-disable-next-line no-prototype-builtins -- TODO: remove this eslint-disable
      storage.hasOwnProperty('analytics') &&
      Object.keys(storage['analytics']).some(
        type => storage['analytics'][type].length > 0 && storage['analytics'][type][0].status === 'delayed',
      )
    ) {
      delayedStorageStatus.analytics = true
    }

    return delayedStorageStatus
  },
)

export const makeGetTimezoneOverride = () =>
  createSelector(
    getFromDesktopProperties(getWillDisplayContactInUserTimezone),
    getUserTimezone,
    (willUseUserTimezone, userTimezone) => (willUseUserTimezone ? userTimezone : null),
  )

export const getHasReviewGoal = createSelector(getContactData, data =>
  Boolean(data.goal && data.goal.action === GOAL_ACTIONS.REVIEW),
)
